//
// エントリー完了画面
//
document.addEventListener("trix-initialize", function (event) {
  const pages = document.getElementsByClassName("edit-completed-setting");
  if (pages.length == 0) return;

  const trixEditor = event.target;
  const trixToolbar = trixEditor.toolbarElement;
  const thanksUrlInput = document.querySelector(".thanks-url");
  const urlRadioLabel = document.querySelector(".url-radio-label");
  const messageRadioLabel = document.querySelector(".message-radio-label");

  const enableThanksUrlType = () => {
    setTimeout(() => {
      thanksUrlInput.disabled = false;
      trixEditor.toggleAttribute("disabled", true);
    }, 0);
    trixToolbar.classList.add("trix-toolbar-disabled");
    urlRadioLabel.classList.add("focused-label");
    messageRadioLabel.classList.remove("focused-label");
  };

  const enableThanksMessageType = () => {
    setTimeout(() => {
      thanksUrlInput.disabled = true;
      trixEditor.toggleAttribute("disabled", false);
    }, 0);
    trixToolbar.classList.remove("trix-toolbar-disabled");
    urlRadioLabel.classList.remove("focused-label");
    messageRadioLabel.classList.add("focused-label");
  };

  const checkedRadio = document.querySelector(".hidden-radio:checked");
  if (!checkedRadio) {
    thanksUrlInput.disabled = true;
    trixToolbar.classList.add("trix-toolbar-disabled");
    urlRadioLabel.classList.remove("focused-label");
    messageRadioLabel.classList.remove("focused-label");
  } else if (checkedRadio.id == "thanks_url_type") {
    enableThanksUrlType();
  } else if (checkedRadio.id == "thanks_message_type") {
    enableThanksMessageType();
  };

  const thanksUrlButton = document.getElementById("thanks-url");
  const thanksMessageButton = document.getElementById("thanks-message");
  thanksUrlButton.addEventListener("change", () => {
    enableThanksUrlType();
  });
  thanksMessageButton.addEventListener("change", () => {
    enableThanksMessageType();
  });
});

document.addEventListener("DOMContentLoaded", (_event) => {
  const pages = document.getElementsByClassName("edit-completed-setting");
  if (pages.length == 0) return;

  // PCサンクスURL設定フォーム制御
  const pcThanksInput = document.querySelector("[data-pc-thanks]");
  const pcThanksUrlInput = document.querySelector("[data-pc-thanks-url");
  const guidanceElement = document.querySelector("[data-guidance");

  pcThanksUrlInput.addEventListener("keyup", (event) => {
    if (event.target.value === "") {
      pcThanksInput.value = false;
    } else {
      pcThanksInput.value = true;
      guidanceElement.classList.remove("hide");
    }
  });
});

//
// 規約設定画面
//
$(function() {
  if($('.edit_terms_setting').length == 0) return;

  $('.tooltip').hide();
  if($('.add-btn .inactive').length) {
    $('.add-btn').on({
      'mouseenter': function () {
        $(this).next().fadeIn('fast');
      },
      'mouseleave': function () {
        $(this).next().fadeOut('fast');
      }
    });
  }
});

//
// 受付状態設定画面
//
$(function() {
  if($('.edit_accepting').length == 0) return;

  $('input.btn-primary').on('click', function(e) {
    if($('#service_accepting_false').is(':checked')) {
      if(!confirm('OFFの状態だとエントリーを受け付けることができません。')) {
        e.preventDefault();
        return false;
      }
    }
  });
});
